import { isEmpty } from 'lodash';

// @deprecated Está todo horrible, el export default no debería de ser ese etc!!!!!
/* global I18n */
export default function humanEnumName(model, enumName, enumValue) {
  if (!enumName) {
    return undefined;
  }

  return I18n.t(
    `activerecord.enums.${model}.${enumName}.${enumValue}`,
    { default: enumValue },
  );
}

export function t(...args) {
  return I18n.t(...args);
}

export function booleanToHuman(valor) {
  let key = valor?.toString();
  if (isEmpty(key)) {
    key = 'nil';
  }
  return t(`boolean.${key}`);
}
